import { PKBillReaderResults } from './pk-bill-reader-results';
import { BillSessionFile } from './bill-session-file';

export class BillSession {
	public sessionId: string;
	public sessionName: string;
	public userId: string;
	public status: string;
	public files: BillSessionFile[];
	public totalFiles: number;
	public successFiles: number;
	public errorFiles: number;
	public s3Path?: string;
	public updatedAt?: string | Date;
	public createdAt?: string | Date;
	public isVerified?: boolean;
	public agentId?: string;
	public agentName?: string;
	public billReaderResults?: PKBillReaderResults[];
	public result: {
		customerName?: string;
		statementDate?: string;
		commodity?: string;
		unit?: string;
		issuer?: string;
	};

	constructor(billSession?: BillSession) {
		Object.assign(this, billSession);
	}
}
